import React from 'react'

interface Th extends React.HTMLProps<HTMLTableCellElement> {
  isHeader?: boolean
  node?: any
}

export const Th: React.FC<Th> = ({ children, isHeader, node, ...props }) => (
  <th
    className="border dark:border-primary-700 text-primary-900 dark:text-primary-100 p-2 font-bold"
    {...props}
  >
    {children}
  </th>
)

export default Th
